import styled from '@emotion/styled';
import { createElement, MouseEventHandler, FC } from 'react';
import { TypographyProps } from '@material-ui/core/Typography';
import RouterLinkBase from './RouterLinkBase';
import theme from '../../../../theme';
import { itemBackground } from '../../../constant/color';

type Props = TypographyProps & {
  type?: 'text' | 'area';
  href: string;
  state?: {
    scroll: boolean;
  };
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  withNewTab?: boolean;
  className?: string;
  innerRef?: any;
};

const RouterLink: FC<Props> = ({ type = 'text', ...props }) => {
  switch (type) {
    case 'text':
      return <AnchorTypography {...props} />;
    case 'area':
      return <AnchorSection {...props} />;
    default:
      return <AnchorTypography {...props} />;
  }
};

const AnchorTypography = styled(RouterLinkBase)({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  '&:active': {
    color: theme.palette.primary.main,
  },
  '&:visited': {
    color: theme.palette.primary.main,
  },
});

const AnchorSection = styled(RouterLinkBase)({
  display: 'block',
  textDecoration: 'inherit',
  color: 'inherit',
  cursor: 'pointer',
  '&:hover': {
    background: itemBackground,
    transition: 'background 0.3s ease',
  },
});

export default RouterLink;
